export const API_BASE_URL = 'https://myapp-backend.wam-portal.jp/webmyapp/v1';
